import { LIST, CREATE, DELETE } from '@/api/modules/exportDataShare.api';

export default {
    list({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        LIST({ payload }, successCallback, errorCallback).then();
    },

    create({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        CREATE({ payload }, successCallback, errorCallback).then();
    },

    delete({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        DELETE({ payload }, successCallback, errorCallback).then();
    }
};
